__webpack_require__.p = "/algebra-two-interactive/public/";